import { CollectionModel, customerApi, QueryTag } from '../api';
import { FeatureCollection, Geometry } from 'geojson';
import { GeofenceProperties } from './interactionsApi';

export interface GeofenceBasicModel {
  id: number;
  n: string; // name
}

// Note: "slope" is deliberately NOT part of this enum!
export enum FenceType {
  Standard = 'Standard',
  Intersection = 'Intersection',
  WetRoad = 'WetRoad',
}

// Purely used for query filters
export enum FilterableFenceType {
  Standard = 'Standard',
  Intersection = 'Intersection',
  WetRoad = 'WetRoad',
  Slope = 'Slope',
}

export const geofencesApi = customerApi.injectEndpoints({
  endpoints: build => ({
    getGeofenceList: build.query<GeofenceBasicModel[], void>({
      query: () => 'api/geofences',
      transformResponse: (response: CollectionModel<GeofenceBasicModel>) => response.items,
      providesTags: (result, error, arg) =>
        result ? [QueryTag.SiteCache, { type: QueryTag.Geofence, id: 'GEOFENCES' }] : [],
    }),
    getSiteGeoJson: build.query<FeatureCollection<Geometry, GeofenceProperties>, string>({
      query: (siteId: string) => ({
        url: `api/sites/${siteId}/geofences`,
        headers: {
          Accept: 'application/vnd.geo+json',
        },
      }),
      providesTags: (result, error, arg) =>
        result ? [QueryTag.SiteCache, { type: QueryTag.Geofence, id: `SITEGEOJSON-${arg}` }] : [],
    }),
  }),
  overrideExisting: false,
});

export const { useGetGeofenceListQuery, useGetSiteGeoJsonQuery } = geofencesApi;
